import { gql, TypedDocumentNode } from "@apollo/client";
import { TEMPLATE_GROUP_FIELDS } from "@graphql/fragments/templateGroup";

import {
  GetTemplateGroupsQuery,
  GetTemplateGroupsQueryVariables,
} from "./TemplateGroups.generated";

export const GET_TEMPLATE_GROUPS: TypedDocumentNode<
  GetTemplateGroupsQuery,
  GetTemplateGroupsQueryVariables
> = gql`
  ${TEMPLATE_GROUP_FIELDS}
  query GetTemplateGroups {
    templateGroups {
      ...TemplateGroupFields
    }
  }
`;
